import React from 'react';
import styled from 'styled-components';
import { StyledTextSpan } from '../../Generic/Text/StyledText';
import { BellaTestIds } from '../../../../common/qaIds';

interface CountLabelProps {
    count: number;
    className?: string;
}

const CountLabelSpan = styled(StyledTextSpan)`
    text-align: right;
`;

export const CountLabel: React.SFC<CountLabelProps> = ({ count }) => (
    <CountLabelSpan textType="button" data-testid={BellaTestIds.filterCount}>
        ({count})
    </CountLabelSpan>
);

export const ListFiltersLayout = styled.div`
    display: flex;
    flex-flow: column;
    color: ${({ theme }) => theme.colors.charcoal100};
`;
